import { Controller } from "@hotwired/stimulus"

// The sites a person may see (Settings -> Team, 29.10.2026): clients open to
// their sites, nothing ticked means no access. "Also future sites" ticks every
// site of the client, unticking one of them clears it. Admin and billing see
// everything, so the sites are hidden for them. Sending waits until a viewer
// has at least one site.
export default class extends Controller {
  static targets = ["level", "panel", "group", "submit", "summary"]
  static values = { none: String, one: String, other: String, countNone: String, countSome: String, countEvery: String, fixed: Boolean }

  connect() { this.update() }

  site(event) {
    if (!event.target.checked) {
      const every = this.every(event.target.closest("[data-access-target=group]"))
      if (every) every.checked = false
    }
    this.update()
  }

  everyChanged(event) {
    if (event.target.checked) this.sites(event.target.closest("[data-access-target=group]")).forEach((box) => { box.checked = true })
    this.update()
  }

  all(event) {
    this.sites(event.target.closest("[data-access-target=group]")).forEach((box) => { box.checked = true })
    this.update()
  }

  none(event) {
    const group = event.target.closest("[data-access-target=group]")
    this.sites(group).forEach((box) => { box.checked = false })
    const every = this.every(group)
    if (every) every.checked = false
    this.update()
  }

  update() {
    const level = this.levelTargets.find((radio) => radio.checked)?.value || "view"
    const viewer = level === "view" || level === "act"
    if (this.hasPanelTarget) this.panelTarget.hidden = !viewer

    let total = 0
    let every = false
    this.groupTargets.forEach((group) => {
      const boxes = this.sites(group)
      const chosen = boxes.filter((box) => box.checked).length
      const all = this.every(group)?.checked
      total += chosen
      every ||= !!all
      const count = group.querySelector("[data-access-count]")
      if (count) {
        count.textContent = all ? this.countEveryValue : chosen ? this.countSomeValue.replace("%{chosen}", chosen).replace("%{total}", boxes.length) : this.countNoneValue
        count.classList.toggle("text-primary", chosen > 0)
        count.classList.toggle("text-secondary", chosen === 0)
      }
      group.classList.toggle("access-group-chosen", chosen > 0)
    })

    const enough = this.fixedValue || !viewer || total > 0 || every
    if (this.hasSubmitTarget) this.submitTarget.disabled = !enough
    if (this.hasSummaryTarget) {
      this.summaryTarget.hidden = !viewer || this.fixedValue
      this.summaryTarget.textContent = enough ? (total === 1 ? this.oneValue : this.otherValue.replace("%{count}", total)) : this.noneValue
      this.summaryTarget.classList.toggle("text-warning-emphasis", !enough)
      this.summaryTarget.classList.toggle("text-secondary", enough)
    }
  }

  sites(group) { return Array.from(group.querySelectorAll("input[name='site_ids[]']")) }

  every(group) { return group.querySelector("input[data-access-every]") }
}
